import { EXTEND_TIME_SESSION, EXTEND_TIME_SESSION_SUCCESS, EXTEND_TIME_SESSION_ERROR, EXTEND_TIME_SESSION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ExtendTimeSession = (state = initialState, action) => {
  switch (action.type) {
    case EXTEND_TIME_SESSION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case EXTEND_TIME_SESSION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case EXTEND_TIME_SESSION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case EXTEND_TIME_SESSION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ExtendTimeSession;
